import React from "react";

export default function AccessExpired() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: 24,
      }}
    >
      <h2>Not able to view the page</h2>
      <p>Please contact admin.</p>
      <button
        onClick={() => {
          localStorage.removeItem("token");
          window.location.href = "/login";
        }}
        style={{ marginTop: 16, padding: "8px 20px", cursor: "pointer" }}
      >
        Back to login
      </button>
    </div>
  );
}
